import React from 'react';
import { Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { IBackButton } from './Type';
import { useTranslation } from 'react-i18next';

const BackButton = ({isFetching=false, onClick}: IBackButton) => {
  const { t } = useTranslation();
  return (
    <>
      <Button 
        sx={{ 
          fontSize: '14px',
          color: 'black',
          padding: '4px 7px 4px 0px',
          verticalAlign: 'middle' 
        }}
        disabled={!!isFetching}
        onClick={onClick}> 
        <ChevronLeftIcon fontSize='small'
        /> {t('Πίσω')}
      </Button>
    </>
  );
};

export default BackButton;